<template>
  <v-card class="hidden">
    <v-toolbar color="indigo" dense>
      <!-- Titolo toolbar -->
      <v-toolbar-title class="white--text">
        {{ nuovo ? "Aggiungi avviso" : "Dettaglio avviso" }}
      </v-toolbar-title>

      <v-spacer />

      <!-- Pulsante info-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
            @click="infoDialog = true"
          >
            <v-icon color="primary"> mdi-information </v-icon>
          </v-btn>
        </template>
        <span>Informazioni Query</span>
      </v-tooltip>

      <!-- Pulsante query-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-5" small v-bind="attrs" v-on="on" @click="editQuery">
            <v-icon color="primary"> mdi-database </v-icon>
          </v-btn>
        </template>
        <span>Query</span>
      </v-tooltip>

      <!-- Pulsante query di controllo -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
            @click="editCheckQuery"
          >
            <v-icon color="primary"> mdi-database-eye </v-icon>
          </v-btn>
        </template>
        <span>Query di Controllo</span>
      </v-tooltip>

      <!-- Pulsante aggiungi variabile-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
            @click="addVariable"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Aggiungi Variabile</span>
      </v-tooltip>

      <!-- Pulsante salva-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            small
            v-bind="attrs"
            v-on="on"
            @click="setNotifica"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer />

      <!-- Pulsante indietro-->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small v-bind="attrs" v-on="on" @click="clickChiudi">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>

    <v-tabs v-model="sel_tab">
      <v-tab>Generale</v-tab>
      <v-tab>Variabili</v-tab>
    </v-tabs>
    <v-tabs-items v-model="sel_tab">
      <v-tab-item>
        <v-form ref="form_notifica">
          <v-row class="pt-5 ml-5 mr-5">
            <v-col cols="6">
              <v-row class="pa-0 ma-0">
                <v-col cols="12">
                  <!-- Descrizione -->
                  <v-textarea
                    outlined
                    validate-on-blur
                    no-resize
                    label="Descrizione"
                    rows="4"
                    :rules="regola_obbligatorio"
                    v-model="notifica.des"
                  />
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0">
                <v-col cols="12">
                  <v-text-field
                    outlined
                    validate-on-blur
                    no-resize
                    label="Link"
                    v-model="notifica.link"
                  />
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0" style="position: relative; top: -22px">
                <v-col cols="8">
                  <!-- Utenti -->
                  <v-autocomplete
                    multiple
                    validate-on-blur
                    no-resize
                    label="Utenti"
                    class="hidden"
                    style="position: relative; top: -12px"
                    :rules="regola_utenti"
                    :items="lista_utenti"
                    :item-text="(e) => e.cognome"
                    item-value="id_utente"
                    :search-input.sync="input_ricerca_utenti"
                    @change="input_ricerca_utenti = ''"
                    v-model="utenti_notifica"
                  />
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="selectAllUsers"
                      >
                        <v-icon color="success"> mdi-check-all </v-icon>
                      </v-btn>
                    </template>
                    <span>Seleziona Tutti</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-2"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="utenti_notifica = []"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                    <span>Diseleziona Tutti</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="6">
              <v-row class="pa-0 ma-0">
                <v-col cols="4">
                  <!-- Data -->
                  <v-text-field
                    disabled
                    label="Data"
                    type="date"
                    class="hidden"
                    v-model="notifica.data_notifica"
                  />
                </v-col>

                <v-col cols="4">
                  <!-- Data inizio validità -->
                  <v-text-field
                    validate-on-blur
                    label="Data inizio validità"
                    type="date"
                    class="hidden"
                    :rules="regola_obbligatorio"
                    v-model="notifica.data_inizio_validita"
                  />
                </v-col>

                <v-col cols="4">
                  <!-- Data fine validità -->
                  <v-text-field
                    validate-on-blur
                    label="Data fine validità"
                    type="date"
                    class="hidden"
                    :rules="regola_obbligatorio"
                    v-model="notifica.data_fine_validita"
                  />
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0">
                <v-col cols="4">
                  <!-- Tipo notifica -->
                  <v-select
                    validate-on-blur
                    label="Tipo"
                    :rules="regola_obbligatorio"
                    :items="lista_notifica_tipi"
                    item-text="des"
                    item-value="id_tabella"
                    v-model="notifica.tipo_notifica"
                  />
                </v-col>

                <v-col cols="4">
                  <!-- Modulo -->
                  <v-autocomplete
                    validate-on-blur
                    label="Modulo"
                    :rules="regola_obbligatorio"
                    :items="lista_moduli"
                    item-text="des_modulo"
                    item-value="id_modulo"
                    v-model="notifica.id_modulo"
                  />
                </v-col>

                <v-col cols="4">
                  <!-- Modulo -->
                  <v-autocomplete
                    label="Sotto-modulo"
                    :items="lista_moduli_menu"
                    item-text="des"
                    item-value="id_modulo_menu"
                    v-model="notifica.id_modulo_menu"
                  />
                </v-col>
              </v-row>

              <!-- Pulsante "Carica immagine" -->
              <v-row class="pa-0 ma-0" style="position: relative">
                <v-col cols="4">
                  <v-file-input
                    outlined
                    class="mt-n1 pt-1 pr-2 hidden"
                    label="Carica un'immagine"
                    style="height: 60px"
                    accept="image/*"
                    v-model="immagine_url"
                    @change="caricaImmagine()"
                  />
                </v-col>
                <!-- Preview immagine -->
                <v-col cols="4">
                  <v-img
                    contain
                    style="width: 100px; height: 54px"
                    :src="immagine_preview"
                  />
                </v-col>

                <v-col cols="4">
                  <!-- Obbligatoria -->
                  <v-switch
                    label="Obbligatorio"
                    class="switch"
                    v-model="notifica.obbligatoria"
                  />

                  <!-- Multipla -->
                  <v-switch
                    label="Multiplo"
                    class="switch"
                    style="top: -18px"
                    v-model="notifica.multipla"
                  />
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0" style="position: relative; top: -34px">
                <v-col cols="8">
                  <!-- Profili -->
                  <v-autocomplete
                    multiple
                    validate-on-blur
                    no-resize
                    label="Profili"
                    class="hidden"
                    :rules="regola_profili"
                    :items="lista_profili"
                    :item-text="(e) => e.des_profilo_utente"
                    item-value="id_profilo_utente"
                    :search-input.sync="input_ricerca_profili"
                    @change="input_ricerca_profili = ''"
                    v-model="profili_notifica"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-5"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="selectAllProfiles"
                      >
                        <v-icon color="success"> mdi-check-all </v-icon>
                      </v-btn>
                    </template>
                    <span>Seleziona Tutti</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mt-5"
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click="profili_notifica = []"
                      >
                        <v-icon color="error"> mdi-close </v-icon>
                      </v-btn>
                    </template>
                    <span>Diseleziona Tutti</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          multi-sort
          :headers="headers"
          :items="variabili.filter((e) => e.validita == 1)"
        >
          <!-- Bottone del testo -->
          <template v-slot:[`item.testo`]="{ item }">
            <v-btn small @click="editText(item)">
              <v-icon
                :color="
                  item.testo != null && item.testo != '' ? 'success' : 'primary'
                "
              >
                mdi-pencil
              </v-icon>
            </v-btn>
          </template>

          <!-- Bottone dello stile -->
          <template v-slot:[`item.stile`]="{ item }">
            <v-btn small @click="editStyle(item)">
              <v-icon
                :color="
                  item.stile != null && item.stile != '' ? 'success' : 'primary'
                "
              >
                mdi-code-block-tags
              </v-icon>
            </v-btn>
          </template>

          <template v-slot:[`item.simbolo`]="{ item }">
            <v-text-field v-model="item.simbolo" />
          </template>
          <template v-slot:[`item.tipo`]="{ item }">
            <v-autocomplete
              :items="tipi"
              v-model="item.tipo"
              item-text="text"
              item-value="id"
            />
          </template>
          <template v-slot:[`item.riga`]="{ item }">
            <v-text-field v-model="item.riga" type="Number" />
          </template>
          <template v-slot:[`item.colonne`]="{ item }">
            <v-text-field v-model="item.colonne" type="Number" />
          </template>
          <template v-slot:[`item.ordine`]="{ item }">
            <v-text-field v-model="item.ordine" type="Number" />
          </template>
          <template v-slot:[`item.val_min`]="{ item }">
            <v-text-field
              v-model="item.val_min"
              type="Number"
              :disabled="item.tipo != 0"
            />
          </template>
          <template v-slot:[`item.val_max`]="{ item }">
            <v-text-field
              v-model="item.val_max"
              type="Number"
              :disabled="item.tipo != 0"
            />
          </template>
          <template v-slot:[`item.query`]="{ item }">
            <v-btn :disabled="item.tipo != 4" small @click="editVarQuery(item)">
              <v-icon color="primary"> mdi-database </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.elimina`]="{ item, index }">
            <v-btn small @click="deleteVariable(item, index)">
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="infoDialog" width="50vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <!-- Titolo toolbar -->
          <v-toolbar-title class="white--text">
            Informazioni Query
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small v-bind="attrs" v-on="on" @click="infoDialog = false">
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <div style="font-size: 18px" class="mt-5">
            I parametri disponibili nella <b>Query</b> sono @id_utente,
            @id_profilo, @id_azienda, @id_utenti, @id_profilo_utente,
            @tipo_notifica, @id_modulo, @obbligatoria, e @multipla.
          </div>

          <div style="font-size: 18px" class="mt-5">
            I campi letti dal risultato della <b>query</b> sono mostra,
            descrizione, percorso e testo_pulsante.
          </div>

          <div style="font-size: 18px" class="mt-5">
            Nella <b>Query di Controllo</b> si può scrivere qualsiasi
            estrazione, ma deve restituire 2 colonne: <b>"codice"</b> e
            <b>"testo"</b>. Il <b>"codice"</b> può valere 0 (tutto ok), 1
            (avviso non bloccante) o 2 (avviso bloccante). Il <b>"testo"</b> è
            arbitrario.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog dello stile -->
    <v-dialog v-model="styleDialog" width="50vw">
      <v-card>
        <v-toolbar color="indigo" dense>
          <!-- Titolo toolbar -->
          <v-toolbar-title class="white--text">
            Modifica Stile Variabile
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                v-bind="attrs"
                v-on="on"
                @click="styleDialog = false"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                v-bind="attrs"
                v-on="on"
                @click="styleDialog = false"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-textarea v-model="sel_var.stile" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog windowframe -->
    <v-dialog class="ma-0 pa-0" v-model="wfVisible" width="90vw">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            referrerpolicy="origin"
            @chiudi_dialog="wfVisible = false"
            @conferma_query="saveQuery"
            @loaded="handleLoaded"
            :component="wfComponent"
            ref="windowframe"
            :input_args="inputArgs"
            :key="keyWf"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "DettaglioNotifiche",
  props: [
    "nuovo",
    "selez",
    "lista_utenti",
    "lista_profili",
    "lista_notifica_tipi",
    "lista_moduli",
  ],
  components: {
    SnackbarQV,
    WindowFrame,
  },

  data() {
    return {
      sel_var: { testo: "", query: "" },
      sel_tab: 0,
      keyWf: true,
      editMode: 0,
      inputArgs: {},
      wfComponent: "",
      // Variabili di supporto.
      input_ricerca_utenti: "",
      input_ricerca_profili: "",
      immagine_url: {},
      immagine_preview: null,
      notifica: {},

      // Modals
      infoDialog: false,
      overlay: false,
      styleDialog: false,
      wfVisible: false,

      // Array.
      lista_moduli_menu: new Array(),
      variabili: [],
      utenti_notifica: [],
      profili_notifica: [],
      tipi: [
        {
          id: 0,
          text: "Input Num.",
        },
        {
          id: 1,
          text: "Input Str.",
        },
        {
          id: 2,
          text: "Data",
        },
        {
          id: 3,
          text: "Checkbox",
        },
        {
          id: 4,
          text: "Select",
        },
        {
          id: 5,
          text: "Informazione",
        },
      ],
      headers: [
        {
          text: "Testo",
          value: "testo",
        },
        {
          text: "Stile",
          value: "stile",
        },
        {
          text: "Simbolo",
          value: "simbolo",
        },
        {
          text: "Tipo",
          value: "tipo",
        },
        {
          text: "Min",
          value: "val_min",
        },
        {
          text: "Max",
          value: "val_max",
        },
        {
          text: "Riga",
          value: "riga",
        },
        {
          text: "Colonne",
          value: "colonne",
        },
        {
          text: "Ordine",
          value: "ordine",
        },
        {
          text: "Query",
          value: "query",
        },
        {
          text: "Elimina",
          value: "elimina",
        },
      ],

      regola_obbligatorio: [
        (e) => {
          if (e != "" && e != null) return true;
          return "Questo campo è obbligatorio.";
        },
      ],

      regola_utenti: [
        (e) => {
          if (!e.length && !this.profili_notifica.length)
            return "Dev'essere compilato almeno il campo profili.";
          return true;
        },
      ],

      regola_profili: [
        (e) => {
          if (!e.length && !this.utenti_notifica.length)
            return "Dev'essere compilato almeno il campo utenti.";
          return true;
        },
      ],
    };
  },

  mounted() {
    if (this.nuovo) {
      // Crea un nuovo oggetto notifica.
      this.notifica = {
        data_fine_validita: null,
        data_inizio_validita: null,
        data_notifica: this.formatData(moment().toDate(), true),
        des: "",
        id_modulo: null,
        id_modulo_menu: null,
        id_notifica: -1,
        id_profilo_utente: "",
        id_utenti: "",
        multipla: 0,
        obbligatoria: 0,
        immagine: null,
        tipo_notifica: null,
        query: "",
        validita: 1,
      };
    } else {
      this.notifica = JSON.parse(JSON.stringify(this.selez)); // Copia oggetto da modificare.
      this.immagine_preview = this.notifica.immagine;
      this.getVariabili();
    }

    // Trasforma le stringhe di utenti e profili in liste (per template autocomplete).
    this.utenti_notifica = this.notifica.id_utenti
      ? this.notifica.id_utenti.split(",").map(Number)
      : [];
    this.profili_notifica = this.notifica.id_profilo_utente
      ? this.notifica.id_profilo_utente.split(",").map(Number)
      : [];
  },
  watch: {
    "notifica.id_modulo": {
      immediate: true,
      handler() {
        if (
          this.notifica.id_modulo == null ||
          this.notifica.id_modulo == undefined
        ) {
          this.lista_moduli_menu = new Array();
        } else {
          this.lista_moduli_menu = JSON.parse(
            JSON.stringify(
              this.lista_moduli.filter(
                (m) => m.id_modulo == this.notifica.id_modulo
              )[0].moduli_menu
            )
          );
          this.lista_moduli_menu.unshift({
            des: "nessuno",
            id_modulo_menu: null,
          });
        }
      },
    },
  },
  methods: {
    editVarQuery(item) {
      this.editMode = 1;
      this.sel_var = item;
      this.inputArgs = { from_esterno: true };
      this.wfComponent = "query";
      this.wfVisible = true;
      this.keyWf = !this.keyWf;
    },
    editText(item) {
      this.editMode = 3;
      this.sel_var = item;
      this.inputArgs = { from_esterno: true };
      this.wfComponent = "query";
      this.wfVisible = true;
      this.keyWf = !this.keyWf;
    },
    editStyle(item) {
      this.sel_var = item;
      this.styleDialog = true;
    },
    deleteVariable(item, index) {
      if (item.id_variabile == -1) {
        this.variabili.splice(index, 1);
      } else {
        item.validita = 0;
      }
    },
    addVariable() {
      this.variabili.push({
        id_variabile: -1,
        nome: "",
        simbolo: "",
        tipo: 0,
        riga: 1,
        collonne: 1,
        query: "",
        validita: 1,
      });
    },
    handleLoaded() {
      if (this.editMode == 0) {
        this.$refs.windowframe.postEvent("setquery", this.notifica.query);
      } else if (this.editMode == 1) {
        this.$refs.windowframe.postEvent("setquery", this.sel_var.query);
      } else if (this.editMode == 2) {
        this.$refs.windowframe.postEvent(
          "setquery",
          this.notifica.query_controllo
        );
      } else if (this.editMode == 3) {
        this.$refs.windowframe.postEvent("setquery", this.sel_var.testo);
      }
    },
    saveQuery(arg) {
      if (this.editMode == 0) {
        this.notifica.query = arg.query;
      } else if (this.editMode == 1) {
        this.sel_var.query = arg.query;
      } else if (this.editMode == 2) {
        this.notifica.query_controllo = arg.query;
      } else if (this.editMode == 3) {
        this.sel_var.testo = arg.query;
      }
    },
    editCheckQuery() {
      this.editMode = 2;
      this.inputArgs = { from_esterno: true };
      this.wfComponent = "query";
      this.wfVisible = true;
      this.keyWf = !this.keyWf;
    },
    editQuery() {
      this.editMode = 0;
      this.inputArgs = { from_esterno: true };
      this.wfComponent = "query";
      this.wfVisible = true;
      this.keyWf = !this.keyWf;
    },
    selectAllUsers() {
      this.utenti_notifica = [];
      for (const u of this.lista_utenti) {
        this.utenti_notifica.push(u.id_utente);
      }
    },
    selectAllProfiles() {
      this.profili_notifica = [];
      for (const p of this.lista_profili) {
        this.profili_notifica.push(p.id_profilo_utente);
      }
    },
    caricaImmagine() {
      var reader = new FileReader();

      // Se l'URL è dichiarato, carica l'immagine.
      if (!this.immagine_url == "") {
        reader.readAsDataURL(this.immagine_url);
        let that = this;

        reader.onload = function () {
          that.notifica.immagine = reader.result;

          // Utilizzo una variabile di supporto ("immagine_preview") poiché il refresh non avviene correttamente
          // se dichiaro come "src" la props "immagine" della notifica.
          that.immagine_preview = that.notifica.immagine;
        };

        reader.onerror = function (error) {
          console.error("Error: ", error);
        };
      } else {
        // Cancella l'immagine.
        this.notifica.immagine = null;
        this.immagine_preview = null;
      }
    },

    clickChiudi() {
      this.notifica = {};
      this.utenti_notifica = [];
      this.profili_notifica = [];
      this.$emit("click_chiudi_dettaglio");
    },

    checkMultiplaObbligatoria() {
      if (this.notifica.obbligatoria && this.notifica.multipla) return true;
      else return false;
    },

    checkDate() {
      let data_inizio = new Date(this.notifica.data_inizio_validita);
      let data_fine = new Date(this.notifica.data_fine_validita);

      return data_inizio <= data_fine;
    },

    formatData(arg, american_format) {
      return arg != null && arg != ""
        ? moment(arg).format(american_format ? "YYYY-MM-DD" : "DD/MM/YY")
        : "";
    },

    setNotifica() {
      // Se i campi obbligatori non sono compilati, arresta la funzione.
      if (!this.$refs.form_notifica.validate()) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Valorizzare tutti i campi obbligatori del form."
        );
        return;
      }

      // Se la data inizio è maggiore della data fine validità, arresta la funzione.
      if (!this.checkDate()) {
        this.$refs.SnackbarQV.print(
          "orange",
          "La data d'inizio è più grande della data di fine."
        );
        return;
      }

      if (this.checkMultiplaObbligatoria()) {
        // Solo una delle due opzioni può essere attiva.
        this.$refs.SnackbarQV.print(
          "orange",
          "L'avviso non può essere multiplo e obbligatorio contemporaneamente."
        );
        return;
      }

      // Trasforma le liste di utenti e profili in stringhe (per BE).
      this.notifica.id_utenti = this.utenti_notifica.toString();
      this.notifica.id_profilo_utente = this.profili_notifica.toString();
      var id_notifica = this.notifica.id_notifica;

      var request = {
        controller: "Notifiche",
        method: "PUT",
        richiesta: {
          action: "setnotifiche",
          token: localStorage.getItem("user_token"),
          notifica: this.notifica,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;
          if (res.status == 200) {
            if (id_notifica == -1) {
              id_notifica =
                res.data.lista[res.data.lista.length - 1].id_notifica;
              await this.setVariabili(id_notifica);
            } else {
              await this.setVariabili(id_notifica);
            }
            this.$emit("salvataggio");
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Impossibile completare il salvataggio."
          );
        });
    },

    async setVariabili(id_notifica) {
      if (this.variabili.length == 0) {
        return;
      }

      for (var v of this.variabili) {
        v.id_notifica = id_notifica;
      }

      var request = {
        controller: "Notifiche",
        method: "PUT",
        richiesta: {
          action: "setvariabili",
          token: localStorage.getItem("user_token"),
          variabili: this.variabili,
        },
      };

      this.overlay = true;
      await this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          this.variabili = res.data.result;
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },

    getVariabili() {
      var request = {
        controller: "Notifiche",
        method: "POST",
        richiesta: {
          action: "getvariabili",
          token: localStorage.getItem("user_token"),
          id_notifica: this.notifica.id_notifica,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.variabili = res.data.result;
      });
    },
  },
};
</script>

<style scoped>
.switch {
  margin: 0;
  padding: 0;
  position: relative;
}

.hidden {
  overflow: hidden;
}
</style>
